import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Textbox } from './../../models/editors/textbox.model';
import { Switch } from './../../models/editors/switch.model';

import { Subscriber } from './../../models/newsletter/subscribers.model';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { Dropdown } from './../../models/editors/dropdown.model';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';

@Component({
  selector: 'swb-subscriber-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService]
})
export class SubscriberDetailComponent extends FormDetailBase<Subscriber> implements OnInit {
  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'email',
        label: 'E-mail',
        validators: [Validators.required, Validators.email]
      }),
      new Dropdown({
        key: 'language',
        label: 'Jazyk',
        options: [
          {
            value: 'cs',
            text: 'cs'
          }
        ],
        value: 'cs'
      }),
      new Switch({
        key: 'subscribed',
        label: 'Přihlášen k odběru',
        value: true,
        labelFalse: 'Odhlášen'
      })
    ];
  }

  public url = 'subscribers';
  protected _redirect = './newsletter';

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {

    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    this._getEntity();

  }

}
